import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  Renderer2,
} from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { WindowRef } from '@x/common/browser';
import { IShopConfig, SHOP_CONFIG } from '@x/ecommerce-shop/config/shop.config';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'x-need-help-bottom-sheet',
  templateUrl: './need-help-bottom-sheet.component.html',
  styleUrls: ['./need-help-bottom-sheet.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'x-need-help-bottom-sheet' },
})
export class NeedHelpBottomSheetComponent implements OnInit, OnDestroy {
  private subscription: Subscription = new Subscription();
  private robin: any = (this.windowRef.instance as any).__robin;

  contactInfo = this.shopConfig.contactInfo;
  enableChat = this.shopConfig.features.enableNeedHelpChat;

  robinDomElement = this.windowRef.document.getElementById('robin_tab_container');

  constructor(
    private bottomSheetRef: MatBottomSheetRef<NeedHelpBottomSheetComponent>,
    private windowRef: WindowRef,
    private renderer: Renderer2,
    @Inject(SHOP_CONFIG) private shopConfig: IShopConfig,
  ) {}

  ngOnInit(): void {
    this.subscription.add(
      this.bottomSheetRef
        .backdropClick()
        .pipe(filter(() => Boolean(this.robin)))
        .subscribe(() => this.hideChat()),
    );
  }

  showChat() {
    if (this.robin) {
      this.renderer.addClass(this.robinDomElement, 'activated');
    }
  }

  hideChat() {
    if (this.robin) {
      this.renderer.removeClass(this.robinDomElement, 'activated');
      this.robin.hide();
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.hideChat();
  }
}
